<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-checkbox
    [dt]="props.dt?.components?.checkbox"
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [label]="props.label"
    [required]="props.required"
    [readonly]="props.readonly"
    [ariaLabel]="props.ariaLabel"
    [isVertical]="props.isVertical"
    [badgeDisabled]="props.badgeDisabled"
    [showDashIfEmptyAndReadOnly]="props.showDashIfEmptyAndReadOnly"
    (changed)="props.change && props.change(field, $event)"
  />

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
